/**
 * External dependencies
 */
import type { ReactNode } from 'react';

export type ButtonGroupProps = {
	/**
	 * The children elements.
	 */
	children: ReactNode;
};
